import React, { useEffect, useState  } from "react";
import { useNavigate } from 'react-router-dom';


import { auth, logout, updateDataByUserId } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import LodingIndicator from "../../components/LoadingIndicator"

import { IMAGES } from "../../constants/index"
import { TITLE } from "../../constants/constants"

import './ProloguePage.css';

const PROLOGUE = [
    "우리의 믿음은\n예수님이 보시기에 어떤 모습일까요?",
    "예수님께서 칭찬하시고\n놀라운 기적을 베푸신\n성경 속 믿음의 사람들을 통해,",
    "우리의 믿음의 크기를 돌아보고\n새롭게 도전하고자 합니다.",
    "예수님께서 친히 칭찬하신\n믿음의 발자취를 따라\n우리도 특별한 기적을 경험하는\n2주간의 믿음 성장 챌린지!",
    "지금이 바로\n당신의 믿음이 새로워지는 순간입니다.",
    "함께 도전하고, 성장하며,\n기적을 목격할 이 특별한 믿음의 여정에",
    "여러분을 초대합니다!",
]

function ProloguePage(){
    let navigate = useNavigate();

    const [init,setInit] = useState(false);
    const [user, setUser] = useState(null);
    const [prologueIndex,setPrologueIndex] = useState(0)
    const [opacity, setOpacity] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false); 
    const [isLoaded, setIsLoaded] = useState(false);


    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        setTimeout(() => {
            setOpacity(1);
        }, 1000); // 0.5초 후 페이드 인
    }, []);

    const handlePrologue = () => {
        if (prologueIndex < PROLOGUE.length&& !isTransitioning) {
            setIsTransitioning(true);
            setOpacity(0); // 🔥 페이드 아웃 시작
            setTimeout(() => {
                setPrologueIndex(prevIndex => prevIndex + 1);
                setOpacity(1); // 🔥 페이드 인 시작
                setTimeout(() => {
                    setIsTransitioning(false); // 🔥 애니메이션 완료 후 다시 클릭 가능
                }, 1500); // 페이드 인이 완료된 후 다시 클릭 가능
            }, 1500); // 0.5초 후 변경
        }
    };
    
    const handleStart = async () => {
        try{
            const data = { "event": {"prologue":true,"epilogue":false}}
            await updateDataByUserId(user.uid,data)
        } catch (e) {
            console.error("프롤로그 이벤트 업데이트 오류", e)
        } finally {
            setOpacity(0); // 🔥 페이드 아웃 시작
            setTimeout(() => {
                handleNavigation('/byFaith')
            }, 1000); // 0.5초 후 변경
        }
    }
    
    const handleNavigation = (address) => {
        navigate(address);
    }
    const handlelogout = async() => {
        const result = await logout()
        navigate('/login');
    }

    function ExternalPage(addrss) {
        // console.log(NOTION,dayIndex,NOTION[dayIndex],addrss)
        return (
            <div style={{ width: "100%", height: "100%" }}>
                {!isLoaded && (
                    <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "18px", color: "#555" }}>
                        <LodingIndicator visiblity={true} color={"#131835"} />
                    </div>
                )}
                <iframe src={addrss} width="100%" height="100%" frameborder="0" onLoad={() => setIsLoaded(true)} allowfullscreen />
            </div>
        );
    }
    // if(!init) return;

    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="prologueWrap" onClick={handlePrologue} style={{ opacity, transition: "opacity 1.5s ease-in-out"}}>
                
                {prologueIndex<PROLOGUE.length&&<div className="contentsTitle" ></div>}
                <div className="contents" style={{paddingTop:`${prologueIndex<PROLOGUE.length? '100px':'0px'}`}}>
                    {prologueIndex<PROLOGUE.length&&<pre>{PROLOGUE?.[prologueIndex] || ""}</pre>}
                    {prologueIndex===PROLOGUE.length&& 
                        <>{ExternalPage("https://instinctive-time-66e.notion.site/ebd/1a299e2dae3880a18698efcf06b748fd")}
                        </>
                    }
                    {prologueIndex===0&&
                    <p className="showHint">터치해주세요</p>
                    }
                </div>
                {prologueIndex===PROLOGUE.length&&
                    <div className="contentsButton">
                        <span onClick={handleStart}>시작하기</span>
                    </div>     
                }
            </div>

        </div>
    );
  }
  export default ProloguePage;